function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m47.683 391.602c9.351 14.302 20.236 27.75 32.601 40.115 46.935 46.934 109.339 72.783 175.716 72.783 17.487 0 34.693-1.812 51.418-5.313v-100.524c-37.336 21.599-79.846 33.122-124.134 33.122-48.889-.001-95.615-14.04-135.601-40.183z",
  fill: "#ffce71"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m256 7.5c-66.377 0-128.781 25.849-175.716 72.784-46.935 46.936-72.784 109.34-72.784 175.716 0 48.89 14.039 95.616 40.183 135.602 39.986 26.144 86.712 40.183 135.601 40.183 44.287 0 86.798-11.523 124.134-33.122v-385.85c-16.725-3.501-33.931-5.313-51.418-5.313z",
  fill: "#676f72"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m359 359c46.935-46.935 72.784-109.339 72.784-175.716 0-48.65-14.897-96.145-40.804-136.01-25.522-16.571-53.77-28.225-83.563-34.461-46.761 9.788-89.728 32.901-124.298 67.471-46.935 46.936-72.783 109.34-72.783 175.716s25.849 128.78 72.784 175.716c.023.023.046.044.069.067.032 0 .064.001.096.001 66.376 0 128.78-25.848 175.715-72.784z",
  fill: "#82888b"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m431.716 80.284c-12.545-12.544-26.199-23.572-40.735-33.01 25.907 39.865 40.803 87.36 40.804 136.01-.001 66.377-25.85 128.781-72.785 175.716-46.935 46.936-109.339 72.784-175.716 72.785-.032 0-.064-.001-.096-.001 34.559 34.532 77.5 57.622 124.23 67.404 46.761-9.788 89.728-32.901 124.298-67.471 46.935-46.937 72.784-109.341 72.784-175.717s-25.849-128.78-72.784-175.716z",
  fill: "#fce3a0"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 183.835,
  cy: 124,
  fill: "#676f72",
  r: 30
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 373.836,
  cy: 109,
  fill: "#676f72",
  r: 15
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m87.501 358.456c0 33.137 26.863 60 60 60 7.138 0 13.786-1.445 20.04-3.828-25.948-31.18-43.605-67.764-51.855-107.034-16.922 10.608-28.185 29.412-28.185 50.862z",
  fill: "#4c5659"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m207.501 358.456c0-33.137-26.863-60-60-60-11.688 0-22.59 3.355-31.815 9.138 8.25 39.271 25.907 75.854 51.855 107.034 2.013-.767 3.987-1.63 5.921-2.575.057.057.114.114 0 0 19.951-9.748 34.039-29.896 34.039-53.597z",
  fill: "#676f72"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m47.916 47.916c4.627-1.191 8.983-3.058 12.956-5.49 4.837-2.96 4.837-9.892 0-12.852-3.973-2.431-8.329-4.298-12.956-5.489-1.191-4.627-3.058-8.983-5.49-12.956-2.96-4.837-9.892-4.837-12.852 0-2.432 3.973-4.298 8.329-5.49 12.957-4.627 1.191-8.983 3.058-12.956 5.489-4.837 2.96-4.837 9.892 0 12.852 3.973 2.432 8.329 4.299 12.956 5.49 1.191 4.627 3.058 8.983 5.49 12.956 2.96 4.837 9.892 4.837 12.852 0 2.432-3.974 4.299-8.33 5.49-12.957z",
  fill: "#ffce71"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m447.965 448.115c6.494-1.672 12.608-4.292 18.184-7.705 6.789-4.155 6.789-13.883 0-18.038-5.576-3.413-11.69-6.033-18.184-7.704-1.672-6.494-4.292-12.608-7.705-18.185-4.155-6.789-13.883-6.789-18.038 0-3.413 5.576-6.033 11.69-7.705 18.185-6.494 1.672-12.608 4.292-18.184 7.704-6.789 4.155-6.789 13.883 0 18.038 5.576 3.413 11.69 6.033 18.184 7.705 1.672 6.494 4.292 12.607 7.705 18.184 4.155 6.789 13.883 6.789 18.038 0 3.413-5.577 6.033-11.691 7.705-18.184z",
  fill: "#ffce71"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 176.831,
  cy: 228.263,
  fill: "#ff8e9e",
  rx: 29.212,
  ry: 23.263,
  transform: "matrix(1 .003 -.003 1 .716 -.553)"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 335.169,
  cy: 228.759,
  fill: "#ff8e9e",
  rx: 29.212,
  ry: 23.263,
  transform: "matrix(-1 -.003 .003 -1 669.62 458.567)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m512 256c0-141.731-114.723-256-256-256-33.912 0-66.789 6.473-97.719 19.238-3.829 1.58-5.652 5.965-4.071 9.794 1.58 3.83 5.966 5.656 9.794 4.071 29.106-12.012 60.058-18.103 91.996-18.103 45.749 0 90.478 12.707 129.554 37.713 25.338 39.536 38.73 84.645 38.73 130.571 0 72.748-32.017 139.178-86.09 184.632-3.171 2.664-3.581 7.396-.916 10.566 2.664 3.171 7.396 3.58 10.566.916 57.527-48.346 91.439-118.973 91.439-196.114 0-37.464-8.371-74.403-24.425-108.525 51.847 45.524 82.142 110.454 82.142 181.241 0 52.346-16.175 101.475-46.888 142.912-1.056-2.18-2.207-4.306-3.455-6.344-6.115-9.993-17.466-8.677-15.416-8.677-6.328 0-12.091 3.243-15.417 8.677-3.091 5.051-5.558 10.432-7.361 16.045-5.61 1.802-10.991 4.27-16.045 7.361-11.581 7.086-11.557 23.759 0 30.832 2.067 1.265 4.193 2.42 6.366 3.475-42.544 31.677-91.505 46.786-141.709 46.786-70.404 0-136.127-29.951-181.742-81.535 33.501 15.587 70.172 23.713 107.773 23.713 49.958 0 98.342-14.328 139.924-41.435 3.47-2.263 4.449-6.909 2.187-10.379-2.263-3.472-6.91-4.449-10.378-2.188-39.139 25.515-84.691 39.001-131.733 39.001-46.438 0-91.349-13.164-129.996-38.071-24.931-38.689-38.11-83.661-38.11-130.173 0-90.907 49.992-169.08 122.869-210.189 3.607-2.035 4.882-6.609 2.847-10.217-2.035-3.607-6.609-4.884-10.217-2.848-76.814 43.328-130.499 126.037-130.499 223.254 0 142.816 116.082 256 257.076 256 54.03 0 107.301-16.415 153.584-51.892 1.459 3.486 3.182 6.864 5.166 10.106 7.085 11.577 23.758 11.561 30.832 0 3.091-5.052 5.559-10.433 7.361-16.045 5.615-1.804 10.996-4.272 16.046-7.363 11.581-7.087 11.557-23.76-.001-30.832-3.247-1.987-6.631-3.712-10.123-5.172 33.898-44.459 52.059-98.339 52.059-154.802zm-49.766 172.769c2.014 1.232 2.016 4.01 0 5.244-5.021 3.073-10.452 5.374-16.141 6.84-2.646.682-4.711 2.747-5.392 5.393-1.464 5.686-3.766 11.115-6.84 16.139-1.23 2.013-4.01 2.017-5.243.001-3.074-5.024-5.375-10.455-6.839-16.14-.681-2.645-2.745-4.71-5.39-5.393-5.696-1.469-11.128-3.771-16.143-6.84-2.014-1.233-2.017-4.011 0-5.244 5.025-3.075 10.455-5.376 16.138-6.838 2.646-.681 4.712-2.747 5.394-5.394 1.465-5.687 3.767-11.117 6.839-16.14 1.233-2.014 4.011-2.016 5.245 0 3.035 4.96 5.399 10.54 6.838 16.136.68 2.648 2.747 4.716 5.395 5.397 5.683 1.463 11.113 3.763 16.139 6.839z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m266 239c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5h-20c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m199 203.5v-10c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m327 203.5v-10c0-4.142-3.358-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v10c0 4.142 3.358 7.5 7.5 7.5s7.5-3.358 7.5-7.5z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m7.213 48.823c3.431 2.1 7.067 3.812 10.853 5.111 1.3 3.784 3.011 7.42 5.111 10.853 5.892 9.627 19.766 9.607 25.647 0 2.099-3.431 3.811-7.066 5.111-10.853 3.786-1.3 7.421-3.012 10.852-5.111 9.627-5.89 9.608-19.768 0-25.646-3.431-2.1-7.067-3.812-10.853-5.111-1.3-3.785-3.012-7.422-5.111-10.853-2.764-4.517-7.558-7.213-12.823-7.213s-10.059 2.696-12.824 7.214c-2.1 3.432-3.811 7.067-5.111 10.852-3.785 1.3-7.421 3.012-10.852 5.111-4.517 2.763-7.213 7.557-7.213 12.823s2.696 10.06 7.213 12.823zm18.74-17.474c2.646-.681 4.713-2.747 5.395-5.394.989-3.844 2.545-7.515 4.682-10.912 2.079 3.396 3.634 7.067 4.624 10.912.681 2.646 2.748 4.713 5.395 5.394 3.842.988 7.513 2.544 10.91 4.68-3.396 2.079-7.067 3.635-10.911 4.625-2.646.681-4.712 2.747-5.393 5.393-.99 3.844-2.545 7.515-4.682 10.912-2.079-3.398-3.635-7.069-4.624-10.911-.681-2.646-2.747-4.713-5.393-5.394-3.844-.99-7.515-2.546-10.912-4.682 3.396-2.079 7.066-3.635 10.909-4.623z"
});

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.0a1a3520.svg";
export { ForwardRef as ReactComponent };